import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiClient, ENV, IEnvironment } from '@shabic/models';
import { ICompanyConfigRequest } from '@shabic/models';

@Injectable({ providedIn: 'root' })
export class CompanyConfigService extends ApiClient {
  override readonly url = '/company-configs';

  constructor(private http: HttpClient, @Inject(ENV) env: IEnvironment) {
    super(env);
  }

  saveConfig(config: ICompanyConfigRequest): Observable<any> {
    return this.http.put(this.apiModelUrl, config);
  }

  getConfig(companyId: number): Observable<ICompanyConfigRequest> {
    return this.http.get<ICompanyConfigRequest>(`${this.apiModelUrl}/company/${companyId}`);
  }
} 